import React from 'react';
import moment from 'moment';
import {useTranslation} from 'react-i18next';

import 'index.css';
import './Controls.css';
import './RetrieveTimePosition.scss';

const RetrieveTimePosition = ({timePosition, retrieve}) => {
  const {t} = useTranslation();
  return (
    <button onClick={() => retrieve(timePosition)} className="retrieve-time-button">
      {t('Reprendre-la-ou-j-en-etais')}
      {' (' + moment.duration(timePosition, 'seconds').format('h:mm:ss', {stopTrim: 'h'}) + ')'}
    </button>
  );
};
export default RetrieveTimePosition;
